export default __webpack_public_path__ + "static/top_staff_img_001-df761d541c18f9dddb53ec16d2e48468.jpg";